import type { GlucoseSubEntry } from "@tandemdiabetes/sugarmate-api-react-client"
import { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { GraphGlucoseDot } from "./GraphGlucoseDot"
import styles from "./GraphGlucoseEntries.module.scss"
import { useEntryModalPublicContext } from "src/components"
import { useFollowedUsers } from "src/contexts"
import { useFindUserEntries } from "src/hooks"
import { createEntryQueryObjectForType } from "src/utils"

interface Props {
  start: string;
  end: string;
}

export function GraphGlucoseEntries(props: Props) {
  const {
    start,
    end,
  } = props

  const { currentUserId } = useFollowedUsers()

  const entriesSelector = useMemo(
    () => createEntryQueryObjectForType(
      currentUserId,
      ActivityType.Glucose,
      {
        selector: {
          started_at: {
            $gte: start,
            $lte: end,
          },
        },
        sort: [{ started_at: "asc" as const }],
      },
    ),
    [
      start,
      end,
      currentUserId,
    ],
  )

  const { result } = useFindUserEntries(entriesSelector)
  const { openEntryModal } = useEntryModalPublicContext()

  return (
    <>
      {result.map((entry) => {
        const glucoseSubentries = entry.subentries.filter(
          (subentry) => subentry.subentry_type === ActivityType.Glucose,
        ) as GlucoseSubEntry[]

        return glucoseSubentries.map((subentry) => (
          <GraphGlucoseDot
            key={subentry._id ?? subentry.offline_id}
            start={start}
            mgdl={subentry.glucose.mg_dl}
            date={entry.started_at}
            className={styles.dot}
            onClick={() => {
              openEntryModal({
                userEntry: entry,
                subEntry: subentry,
              })
            }}
          />
        ))
      })}
    </>
  )
}
